import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Principal, Account } from 'src/app/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { StateStorageService } from 'src/app/core/auth/state-storage.service';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { TypeOfClient } from 'src/app/shared/model/client.model';

@Component({
    selector: 'jhi-bulk-no-rules',
    templateUrl: './bulk-no-rules.component.html',
    styles: []
})
export class BulkNoRulesComponent implements OnInit {
    istypeOfClientTrader = false;

    constructor(public principal: Principal,
         private activatedRoute: ActivatedRoute,
          private stateStorageService: StateStorageService,
          private languageChangeService: LanguageChangeService
          ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
           }

    ngOnInit() {
        this.principal.identity(true).then(account => {
            console.log(account);
            if (account.typeOfClient) {
                this.clientType(account.typeOfClient);
            } else {
                const typeOfClient = this.stateStorageService.getTypeOfClient();
                this.clientType(typeOfClient);
            }
        });
    }

    clientType(typeOfClient) {
        if (typeOfClient === TypeOfClient.TRADER) {
            this.istypeOfClientTrader = true;
        } else {
            this.istypeOfClientTrader = false;
        }
    }
}
